/* eslint-disable max-len */
import { USER_TYPE } from '../../../../bitConstants/constants';
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import { URLS } from '../../errorTextsConstants';
import {
  BUTTON_COLOR,
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
} from '@bitComponents/unifiedComponents/Button';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      INCOMPATIBLE_PRODUCT: {
        errorInfo: {
          title: 'Lo sentimos, actualmente no cumples las condiciones para renovar tu dispositivo.',
          msg: ["Descubre la oferta que tenemos disponible para ti"],
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            link: URLS.VTL_CATALOG,
            label: "Ir a móviles y electrónica",
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
        },
      },
      AUTO_RENEWAL_FAIL: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Hemos tenido un problema realizando tu pedido',
          msg: [
            'Es necesario que vayas a una tienda de Movistar o llames gratis al 1004 para gestionarlo, sentimos las molestias ocasionadas',
          ],
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            link: URLS.SEARCH_SHOP,
            label: 'Localizar tienda',
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          errorName: 'producto r2r adicional no disponible',
        },
      },
      BLOCKED_USER: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          title: 'Recogida en tienda del dispositivo',
          msg: [
            'Por seguridad la recogida y firma del contrato de arrendamiento del dispositivo en el caso de autónomos debe realizarse en una tienda Movistar para validar tu identidad.',
            'Si lo deseas, puedes pedir una cita previa en tienda para realizarlo.',
          ],
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              onClick: () => {
                window.location.href = URLS.BOOK_SHOP_APPOINTMENT;
              },
              label: 'Solicitar cita previa',
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.MEDIUM,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'cif user blocked',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
